var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"MuiSvgIcon-root styles_checkIcon__MTHEd",attrs:{"focusable":"false","viewBox":"0 0 24 24","aria-hidden":"true","title":"Verified Collection"}},[_c('path',{attrs:{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }